<template>
  <a-result status="403" title="403" subTitle="抱歉，您没有访问该页面的权限！">
    <template v-slot:extra>
      <a-button type="primary" @click="()=>{$router.push({path: '/'})}">返回首页</a-button>
    </template>
  </a-result>
</template>

<script>
export default {
  data () {
    return {}
  },
  methods: {},
  computed: {},
  components: {}
}
</script>

<style scoped>
</style>